import { BaseLayout } from "@components/general/base_layout";
import { Header } from "@components/general/header";
import { Outlet } from "react-router-dom";

import PreloadLogo from "@assets/images/logo-khoiriyah.png";
import { useThemeStore } from "@stores/theme.store";
import { useEffect } from "react";

export const AuthPage = () => {
  const { setBottomNavigation } = useThemeStore((state) => state);
  useEffect(() => {
    setBottomNavigation("hidden");
  }, [setBottomNavigation]);
  return (
    <BaseLayout>
      <Header>
        <div className="tw-bg-background-200 page-title">
          <div className="tw-pt-20 tw-pb-10 tw-text-center">
            <img
              src={PreloadLogo}
              alt="Logo Darul Ulum"
              className="tw-w-4/5 tw-pb-8 tw-px-[0px] md:tw-w-2/4 lg:tw-w-1/3"
            />
          </div>
        </div>
      </Header>
      <Outlet />
    </BaseLayout>
  );
};
